<ng-container *transloco="let t;">
  <form (submit)="onSubmit()" novalidate *ngIf="exercise !== null">

    <div class="p-grid">
      <div class="p-col-6">
          <h2>{{ t('common.labels.competences') }}</h2>
      </div>
      <div class="p-col-6 p-text-right" *ngIf="inEdit !== true && competenceBlocks.length === 1">
        <button withRight="admin.exercise.edit" pButton (click)="onNew(competenceBlocks[0])" type="button" label="{{ t('common.labels.new') }}" icon="pi pi-plus" class="p-button-sm p-button-success p-mb-2 autofocus"></button>
      </div>
      <div class="p-col-6 p-text-right" *ngIf="inEdit !== true && competenceBlocks.length > 1">
        <button pButton (click)="menu.toggle($event)" type="button" label="{{ t('common.labels.new') }}" icon="pi pi-plus" class="p-button-sm p-button-success p-mb-2"></button>
        <p-menu #menu [popup]="true" [model]="items" [style]="{width: '300px'}"></p-menu>
      </div>
    </div>

    <div *ngIf="exercise !== null">

      <div *ngFor="let block of competenceBlocks">

        <h3 *ngIf="competenceBlocks.length > 1">{{ t('common.labels.exercisepart') }}: {{block.exercisepart.name}}</h3>

        <div class="p-mb-4">
          <p-table *ngIf="(inEdit === true && editBlock === block) || block.entries.length > 0" [value]="block.entries">
            <ng-template pTemplate="header">
              <tr>
                  <th style="width: 25%;">{{ t('common.labels.competence') }}</th>
                  <th>{{ t('common.labels.behavioranchors') }}</th>
                  <th style="width: 10rem;"></th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-entry>
              <tr *ngIf="inEdit !== true || editBlock != block || editEntry !== entry ">
                  <td style="vertical-align: top;"><p>{{ entry.competence?.getLang('name', transloco.getActiveLang()) }}</p></td>
                  <td>
                    <p *ngFor="let behavioranchor of entry.behavioranchors">
                      <span class="anchor">{{ behavioranchor.content }}</span>
                      <span *ngIf="behavioranchor.expression_positive" class="expression"><label>{{ t('common.labels.positive') }}</label>: {{ behavioranchor.expression_positive }}</span>
                      <span *ngIf="behavioranchor.expression_negative" class="expression"><label>{{ t('common.labels.negative') }}</label>: {{ behavioranchor.expression_negative }}</span>
                    </p>
                  </td>
                  <td style="vertical-align: top; text-align: right">
                    <span *ngIf="inEdit !== true">
                      <button withRight="admin.exercise.edit" pButton (click)="onEdit(block, entry)" type="button" icon="pi pi-pencil"></button>
                      <button withRight="admin.exercise.edit" pButton (click)="onDelete(block, entry)" type="button" icon="pi pi-trash" class="p-button-outlined danger-button p-ml-2"></button>
                    </span>
                  </td>
                </tr>
              <tr *ngIf="inEdit === true && editBlock === block && editEntry === entry">
                <ng-template [ngTemplateOutlet]="tForm"></ng-template>
              </tr>
            </ng-template>
            <ng-template pTemplate="footer">
              <tr *ngIf="inEdit === true && editBlock === block && editEntry === null">
                <ng-template [ngTemplateOutlet]="tForm"></ng-template>
              </tr>
            </ng-template>
          </p-table>

          <p *ngIf="(inEdit !== true && block.entries.length === 0) || (inEdit === true && editBlock !== block && block.entries.length === 0)">{{ t('common.texts.no_competences') }}</p>

        </div>

      </div>

      <ng-template #tForm>
        <td style="vertical-align: top;">
          <app-form-control *ngIf="editEntry === null" [cid]="'competence'" [control]="form.get('competence')" [type]="'select'" [options]="optionsCompetences" [optionLabel]="'name.' + transloco.getActiveLang().toUpperCase()" [label]="''"></app-form-control>
          <p *ngIf="editEntry !== null">{{editEntry.competence.getLang('name', transloco.getActiveLang())}}</p>
        </td>
        <td>
          <div *ngFor="let control of form.get('behavioranchors')['controls']; let i = index" class="p-grid">
              <div class="p-col">
                <app-form-control [cid]="'behavioranchor' + i + '_content'" [control]="control.get('content')" [label]="t('common.labels.behavioranchor_content')" [type]="'input'"></app-form-control>
                <div class="expression-form">
                    <app-form-control [cid]="'behavioranchor' + i + '_pos'" [control]="control.get('expression_positive')" [label]="t('common.labels.positive')" [type]="'input'"></app-form-control>
                    <app-form-control [cid]="'behavioranchor' + i + '_neg'" [control]="control.get('expression_negative')" [label]="t('common.labels.negative')" [type]="'input'"></app-form-control>
                </div>
              </div>
              <div class="p-col-fixed" style="width: 30px; padding-top: 2rem;">
                <button *ngIf="form.get('behavioranchors')['controls'].length > 1" pButton (click)="deleteBehavioranchorEntry(i)" type="button" icon="pi pi-trash" class="p-button-outlined"></button>
              </div>
          </div>
          <a (click)="addBehavioranchorEntry()" class="pointer"><fa-icon [icon]="faPlus"></fa-icon> {{ t('common.labels.add_behavioranchors') }}</a>
        </td>
        <td style="vertical-align: top; text-align: right">
          <app-form-buttons [submitting]="submitting" [icons]="false" (cancelled)="onCancel()"></app-form-buttons>
        </td>
      </ng-template>

    </div>

  </form>

  <app-inherit-dialog
    [title]="t('common.labels.save')"
    [mode]="'exercise'"
    [(visible)]="saveInheritVisible"
    (okClicked)="saveCompetence($event)"
  ></app-inherit-dialog>

  <app-inherit-dialog
    [title]="t('common.labels.delete')"
    [mode]="'exercise'"
    [(visible)]="deleteInheritVisible"
    (okClicked)="deleteCompetence($event)"
  ></app-inherit-dialog>

</ng-container>
